import { PriceTransparencyLevelEnum } from '@rover/rsdk/src/apiClient/latest/model/priceTransparencyLevelEnum';

export type PriceTransparencyLevel = PriceTransparencyLevelEnum;

export const PriceTransparencyLevels = PriceTransparencyLevelEnum;
